/*
  Contains build information about which server domain to access depending on 
  whether react client is in dev, tesing, or production mode
*/

// Google OAuth client ID is selected by HOSTNAME so a single build can serve
// both clubwealthu.com (original app) and learning.clubwealth.com (new app) at
// the same time during the domain migration. We use the new-domain app on
// learning(dev).clubwealth.com because we don't have console access to the
// original app's Google project. MUST stay in sync with getGoogleCredentials()
// in InfusionsoftIntegration/oauthCredentials.js (which picks GG_REPLIT_* for
// the same hosts). Facebook + Microsoft intentionally stay on the original apps.
const ORIGINAL_GOOGLE_CLIENT_ID =
  '865629118314-1f3ftm3j7bncakfqt6stf9lm72tk7446.apps.googleusercontent.com';
const NEW_DOMAIN_GOOGLE_CLIENT_ID =
  '869045140804-pqhenur288tp06tg6ek3uq7q40fr2k83.apps.googleusercontent.com';
const NEW_FRONTEND_HOSTS = [
  'learning.clubwealth.com',
  'learningdev.clubwealth.com'
];
const googleClientId =
  typeof window !== 'undefined' &&
  NEW_FRONTEND_HOSTS.includes(window.location.hostname)
    ? NEW_DOMAIN_GOOGLE_CLIENT_ID
    : ORIGINAL_GOOGLE_CLIENT_ID;

module.exports = {
  googleClientId,
  baseUrl:
    process.env.NODE_ENV === 'production'
      ? window.location.origin
      : 'http://localhost:3001',
  developmentRedirectUrl: 'https://127.0.0.1',
  productionRedirectUrl: 'https://clubwealthu.com',
  redirectUrl:
    process.env.mode === 'production'
      ? 'https://clubwealthu.com'
      : 'https://127.0.0.1',
  mediaServerBaseUrl:
    process.env.REACT_APP_MEDIA_TEST === 'true'
      ? 'http://localhost:4443'
      : 'https://videoapi.clubwealth.com'
};
